import Action from 'src/react/components/breadcrumbs/types/Action';
import { BREADCRUMBS_REMOVE } from 'src/react/components/breadcrumbs/constants';

const breadcrumbsRemove = (id: string): Action => ({
  type: BREADCRUMBS_REMOVE,
  payload: {
    id,
  },
});

export default breadcrumbsRemove;
